import './polyfill.js'

import React from 'react';
import { render } from "react-dom";
import App from "src/modules/App";
import store from 'src/app/store';
import { isLocal } from 'src/utils/helpers';
import * as serviceWorker from "./serviceWorker";
import { appUpdated } from 'src/modules/App/actions';

import * as Sentry from '@sentry/browser';

const sentryDnsAndToken = process.env.REACT_APP_SENTRY || null

Sentry.init({
  dsn: isLocal() ? null : sentryDnsAndToken,
  release: process.env.REACT_APP_VERSION,
  maxBreadcrumbs: 50,
  ignoreErrors: [
    `(NetworkError: Failed to execute 'send' on 'XMLHttpRequest': Failed to load)*(favicon.ico)`,
    `favicon.ico`,
  ],
});

render(<App />, document.getElementById("root"));

serviceWorker.register({
  onUpdate: function() {
    store.dispatch(appUpdated());
  }
});

// expose store when run in Cypress
if (window.Cypress) {
  window.store = store
}
